/*
 * Safe redirect helper
 * - Disallows unsafe schemes (javascript:, data:, vbscript:, etc.)
 * - Resolves relative URLs against the current origin so relative paths continue to work
 * - Only allows http and https protocols by default
 */
const ALLOWED_PROTOCOLS = ["http:", "https:"];

const isSafeProtocol = (protocol: string | null): boolean => {
  if (!protocol) return false;
  return ALLOWED_PROTOCOLS.includes(protocol);
};

export const safeRedirect = (url?: string): void => {
  if (!url) return;

  try {
    const parsed = new URL(url, window.location.origin);

    if (!isSafeProtocol(parsed.protocol)) {
      console.warn("Blocked unsafe redirect to protocol:", parsed.protocol, "url:", url);
      return;
    }

    window.location.href = url;
  } catch (e) {
    // Invalid URL — do nothing and warn
    console.warn("Blocked invalid redirect URL:", url, e);
  }
};

export default safeRedirect;
